import { mountRootParcel } from 'single-spa';

import { Divider } from 'netline-ui';
import services from 'services';
import { OthersMenuComponentItem, OthersMenuItem, OthersMenuItemType, OthersMenuWidgetItem } from 'types';

import Parcel from '../../ApplicationModule/Parcel';

export const isWidgetOthersMenuItem = (item: OthersMenuItem): item is OthersMenuWidgetItem =>
  item.type === OthersMenuItemType.WIDGET;

type MobileOthersMenuItemProps = {
  item: OthersMenuItem;
};

const MobileOthersMenuItem = ({ item }: MobileOthersMenuItemProps) => {
  const { type, id } = item;

  if (type === OthersMenuItemType.DIVIDER) {
    return (
      <div data-testid="MobileOthersMenuItem-divider">
        <Divider />
      </div>
    );
  }

  if (isWidgetOthersMenuItem(item)) {
    const widgetConfig = services.getWidget(item.widget) || null;
    if (widgetConfig) {
      return (
        <Parcel
          key={item.widget}
          wrapClassName="MobileOthersMenu-parcel"
          config={widgetConfig}
          services={services}
          mountParcel={mountRootParcel}
        />
      );
    }
  }

  if (type === OthersMenuItemType.COMPONENT) {
    const { Component, ComponentProps } = item as OthersMenuComponentItem;
    return <Component key={id} data-testid={id} {...ComponentProps} />;
  }
  return null;
};

export default MobileOthersMenuItem;
